import { render, staticRenderFns } from "./boletim-novo-Modelo.vue?vue&type=template&id=6ffbd8c8&"
import script from "./boletim-novo-Modelo.vue?vue&type=script&lang=js&"
export * from "./boletim-novo-Modelo.vue?vue&type=script&lang=js&"
import style0 from "./boletim-novo-Modelo.vue?vue&type=style&index=0&id=6ffbd8c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports